import classNames from 'classnames';
import { type ReactNode,useState } from 'react';

import {
	Accordion,
	AccordionBody,
	AccordionHeader,
	Box,
	Group,
	Text,
} from '@ekhodealer/ekho-common/rev';

import './AccordionSection.scss';

interface AccordionSectionProps {
	/** The title to display in the accordion header */
	title: string;
	/** The content to display in the accordion body */
	children: ReactNode;
	/** Optional content to display on the right side of the accordion header */
	rightAccessory?: ReactNode;
	/** Whether the accordion should be expanded by default */
	defaultExpanded?: boolean;
	/** Optional className to apply to the accordion section */
	className?: string;
}

/**
 * AccordionSection component that provides a consistent structure
 * for accordion sections with standardized styling
 */
export function AccordionSection({
	title,
	children,
	rightAccessory,
	defaultExpanded = false,
	className,
}: AccordionSectionProps) {
	const [isExpanded, setIsExpanded] = useState(defaultExpanded);

	return (
		<Accordion isExpanded={isExpanded} onExpandedChange={setIsExpanded} className={classNames('accordion-section', className)}>
			<AccordionHeader>
				<Box padding={{ y: 20, x: 0 }}>
					<Group itemsAlignX='space-between' itemsAlignY='center' noWrap>
						<Group.Item>
							<Text size='body' weight='semibold' align='left'>
								{title}
							</Text>
						</Group.Item>
						{rightAccessory && <Group.Item>{rightAccessory}</Group.Item>}
					</Group>
				</Box>
			</AccordionHeader>
			<AccordionBody>
				<Box padding={{ top: 12, bottom: 12 }}>{children}</Box>
			</AccordionBody>
		</Accordion>
	);
}
